import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class FairCatch extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.FairCatch;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.setPossessionForTeamId(fragment.fairCatchBy.teamId);
        gameContext.setCurrentPlayerInPossession(fragment.fairCatchBy);
    }
}
